
import * as React from "react";

import './TextField.scss';

export const TextField = ({ id, inputType = 'text', placeholder, value, required = false, onChange = (event) => {}, disabled = false, type = 'default-input' }) => {
    return (
        <div className={`field ${type}`}>
            <input type={inputType} id={id}
                   data-testid={id}
                   className="input_input-field"
                   value={value}
                   placeholder=""
                   required={required}
                   onChange={onChange}
                   disabled={disabled}
            />
            <label htmlFor="text-input">{placeholder}</label>
        </div>
    );
};
